// extracted by mini-css-extract-plugin
export default {"container":"assets_container__kpzQU","header":"assets_header__LDDLC","title":"assets_title__itaxA"};